import React, {memo, useMemo} from 'react';

import {Box} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {PaymentLinkLogo} from '@/app/main/paymentLink/components/PaymentLinkLogo/PaymentLinkLogo';

import {CO_PARENT_IMAGES} from '../constants';

interface CoparentHeaderProps {
  inviterName: string;
}

export const CoparentHeader = memo(({inviterName}: CoparentHeaderProps) => {
  const {t} = useTranslation();

  const title = useMemo(
    () =>
      inviterName
        ? t('co_parent.invitation.title_with_inviter', {inviter: inviterName})
        : t('co_parent.invitation.title_default'),
    [inviterName, t],
  );

  return (
    <Box className="co-parent-header">
      <Box className="co-parent-header__logo">
        <PaymentLinkLogo />
      </Box>
      <h1 className="co-parent-header__title">{title}</h1>
      <img
        className="co-parent-header__illustration"
        src={CO_PARENT_IMAGES.INVITATION_ILLUSTRATION.src}
        alt={CO_PARENT_IMAGES.INVITATION_ILLUSTRATION.alt}
      />
    </Box>
  );
});

CoparentHeader.displayName = 'CoparentHeader';
